<template>
  <div>
    <AppBreadcrumb 
      @fetch-excel="fetchConsultarCitaExcel" 
      @fetch-pdf="fetchConsultarCitaPdf"
    />
  
    <b-row class="mb-1" :style="{ marginTop: canCreateCitas ? '-30px' : '0px' }">
      <div class="col-9 d-flex justify-content-end">

        <b-button
          v-if="canCreateCitas"
          variant="success"
          @click="redirectToCrearCita"
        >
          Crear
        </b-button>
      </div>
    </b-row>

    <b-row class="d-flex justify-content-end">
      

      <b-card class="col-9 mx-0">
        <b-row class="mt-2">

          <b-form-input 
            v-model="filters.search"
            placeholder="Buscar por nombres, apellidos, especialidard o cedula" 
            type="text"
            :class="isXima ? 'col-4 mb-1' : 'col-5 mb-1'" 
          />
          
          <v-select 
            id="especialidad" 
            v-model="filters.especialidad" 
            :options="opsespecialidad"
            placeholder="Buscar por Especialidad." 
            label="text"
            :class="isXima ? 'col-3' : 'col-4'"
          />

          <v-select
            v-if="isXima"
            id="establecimiento"
            v-model="filters.establecimiento"
            :options="establecimientos"
            placeholder="Buscar por establecimiento."
            label="text"
            class="col-3"
            :reduce="option => option"
          />

          <v-select 
            id="cobertura" 
            v-model="filters.cobertura" 
            :options="opsCobertura"
            placeholder="Buscar por cobertura." 
            label="text"
            :class="isXima ? 'col-2' : 'col-3'"
          />

          <v-select 
            v-model="filters.estadoCita" 
            :options="opsEstadoCita"
            placeholder="Buscar por estado." 
            label="text"
            class="col-3"
          />

          <v-select 
            v-model="filters.estadoRevision" 
            :options="opsEstadoRevision"
            placeholder="estado revision" 
            label="text"
            class="col-3"
          />


          <b-form-checkbox
            v-model="filters.fechaHoy"
            switch
            class="col-2"
          >Citas de hoy</b-form-checkbox>

          <b-col md="2" v-if="!filters.fechaHoy">
            <label for="fecha-desde">Fecha(desde):</label>
            <flat-pickr 
              v-model="filters.fechaDesde" 
              placeholder="DD/MM/AAAA" 
              :config="configdateTimePicker"
              class="form-control" 
            />
          </b-col>

          <b-col md="2" v-if="!filters.fechaHoy">
            <label for="fecha-hasta">Fecha(hasta):</label>
            <flat-pickr 
              v-model="filters.fechaHasta" 
              placeholder="DD/MM/AAAA" 
              :config="configdateTimePicker"
              class="form-control"
            />
          </b-col>

        </b-row>

        <b-row class="mt-1">
          <b-col 
            md="3" 
            class="d-flex align-items-end"
          >
            <b-button 
              variant="primary" 
              @click="buscarCita"
            >
              <font-awesome-icon 
                icon="magnifying-glass" 
                style="color: white;" 
              /> 
              <span style="color: white;"> Buscar</span>
            </b-button>

            <b-button 
              class="ml-1" 
              variant="warning" 
              title="Limpiar filtros"
              @click="onClearFilters"
            >
              <i class="fa-solid fa-eraser"/>
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="col-3" style="border: 1px solid #c9c9c9">
        <h4 class="mb-1">Documentos faltantes</h4>
        <div class="row d-flex align-items-center mb-1">
          <h5 class="col mb-0">Sin MSP: </h5>
          <span class="">{{cantidadMSPFaltantes}} (total)</span>
          <b-form-checkbox
            v-model="filters.observaciones"
            :value="'sinMsp'"
            switch 
            size="md"
            class="ml-2"
          />
        </div>


        <div class="row d-flex align-items-center mb-1">
          <h5 class="col mb-0">Sin H. Clinica: </h5>
          <span class="">{{nCitasSinAtencion}} (total)</span>
          <b-form-checkbox
            v-model="filters.observaciones"
            :value="'sinHistoria'"
            switch 
            size="md"
            class="ml-2"
          />
        </div>
      </b-card>
    </b-row>
    

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">


        <div class="d-flex justify-content-between mb-1 mx-1">
          <div class="d-flex text-success align-items-center">
            <i class="fa-solid fa-filter"/>
            <span class="mx-1" v-html="getFiltrosAplicados"></span>
          </div>
          <h5>Resultados: {{ table.totalRows }}</h5>
        </div>
    
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-skeleton-wrapper :loading="loadingTable">
            
            <template #loading>
              <b-skeleton-table
                :rows="10"
                :columns="12"
                :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </template>

            <b-table 
              v-if="items.length > 0 && !loadingTable" 
              bordered striped responsive 
              :per-page="table.perPage"
              :items="items" 
              :fields="tableFields" 
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" 
              :sort-direction="sortDirection" 
              
            >
              <template #cell(estadoCita)="data">
                <div class="estado-cita">{{ showAppointmentState(data.value) }}</div>
              </template>

              <template #cell(estadoRev)="data">
                <div class="estadoDerivacion">{{ estadoRevisionShow(data.value) }}</div>
              </template>
            
              <template #cell(acciones)="data">
                <div class="d-flex justify-content-end">

                  <ButtonComentariosValidacion
                    :tokenCita="data.item.tokenCita"
                  />

                  <b-button 
                    v-if="showButtonVerCita" 
                    variant="info" size="sm"
                    @click="viewItem(data.item.tokenCita, data.item.idCita)"
                    title="Ver Cita"
                  >
                    <font-awesome-icon 
                      icon="magnifying-glass" 
                      style="color: white;" 
                      title="Ver Cita" 
                    />
                  </b-button>

                  <!-- <b-button 
                    v-if="hasPermission('citamedica_eliminar_cita')" 
                    variant="danger" 
                    size="sm"
                    @click="removeItemid(data.item.idCita)"
                    title="Eliminar Cita" 
                  >
                    <font-awesome-icon 
                      icon="circle-xmark" 
                      style="color: white;"
                    />
                  </b-button> -->

                  <b-button 
                    v-if="showButtonCrearSignos(data.item)"
                    variant="danger" size="sm"
                    @click="signosVitalid(data.item.tokenCita)">
                    <font-awesome-icon icon="heart" style="color: white;" title="Signos Vitales" />
                  </b-button>

                  <b-button 
                    v-if="showButtonEditarSignos(data.item)"
                    variant="success" size="sm"
                    @click="signosVitalid(data.item.tokenCita)">
                    <font-awesome-icon icon="heart" style="color: white;" title="Signos Vitales" />
                  </b-button>

                  <b-button 
                    v-if="data.item.estadoCita === '2' && hasPermission('atencionmedica_crear_atencion')" 
                    size="sm"
                    @click="redirectToAtencionMedica(data.item.idCita)"
                    title="Atencion Medica"
                  >
                    <i class="fas fa-user" />
                  </b-button>

                  <b-button 
                    variant = "warning" 
                    v-if="showButtonEditarAtencion(data.item)" 
                    size="sm"
                    @click="redirectToEditAtencionMedica(data.item.tokenAtencion)"
                    title="Editar Atencion Medica"
                  >
                    <i class="fas fa-user"/>
                  </b-button>

                </div>
              </template>
              <template #cell(archivosMsp)="data">
                <span 
                  style="text-align: center;" 
                  :class="data.item.cobertura !== 'PARTICULAR' ? data.item.colorArchivoMsp : '' "
                >
                  {{ data.item.cobertura !== 'PARTICULAR'
                    ? `Subidos ${data.item.nCoberturasSubidas}/${data.item.nTitulares}` 
                    : `No aplica` }}
                </span>
              </template>
              <template #cell(fechaCreacion)="data">
                <span>
                  {{ data.item.fechaCreacion }}
                </span>
              </template>
              <template #cell(coberturaSeguro)="data">
                <span style="color: blue;" v-if="data.item.cobertura === 'PARTICULAR'">
                  {{ data.item.coberturaSeguro }}
                </span>
                <span v-else>
                  {{ data.item.coberturaSeguro }}
                </span>
              </template>
              <template #cell(informes)="data">
                 <div class="d-flex justify-content-end">
                  <b-button 
                    v-if="isOdontologia(data.item)" 
                    size="sm"
                    @click="downloadForm033(data.item.idCita)"
                    title="Formulario 033"
                  >
                    <i class="fa-solid fa-file-pdf"></i>
                  </b-button>
                </div>
                <div class="d-flex justify-content-end">
                  <b-button 
                    v-if="canDownloadActaEntrega(data.item.estadoCita)" 
                    size="sm"
                    @click="informesService.getActaEntrega(data.item.idCita)"
                    title="Acta de Entrega"
                  >
                    <i class="fas fa-paperclip"/>
                  </b-button>
                </div>
  
                <div class="d-flex justify-content-end">
                  <b-button 
                    v-if="canDownloadCertificadoAsistencia(data.item.estadoCita)"
                    size="sm" 
                    @click="informesService.getCertificadoAsistencia(data.item.idCita)"
                    title="Asistencia"
                  >
                    <i class="fas fa-bell"/>
                  </b-button>

                  <b-button 
                    v-if="canDownloadCertificadoDescanso(data.item)" 
                    size="sm"
                    @click="informesService.getCertificadoDescanso(data.item.idCita)">
                    <i class="fas fa-certificate" title="Certificado Médico"/>
                  </b-button>
  
                </div>
              </template>
          
            </b-table>
          </b-skeleton-wrapper>

          <div v-if="items.length < 1 && !loadingTable" class="text-center">
            <p>No se encontraron registros</p>
          </div>
          
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination 
            v-model="table.page" 
            :total-rows="table.totalRows"
            :per-page="table.perPage"
            first-number
            class="mb-0" 
            align="center" 
            prev-class="prev-item"
            next-class="next-item" 
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>
    
    <b-modal 
      v-model="showModal" 
      @show="cargarComponente" 
      size="xl"
      hide-footer
    >
      <component 
        :is="componenteDinamico" 
        v-if="componenteDinamico" 
        :tokenCita="tokenSeleccionado"
      >
      </component>
    </b-modal>


    <SaveSignosVitales/>
    <SignoModalEdit 
      :dataSignos.sync="dataEditSignoModal" 
      :edadPaciente = "edadPaciente" 
      :fechaCita = "fechaCita" 
      :paciente = "paciente" 
    />

    <CitasComentariosValidacion/>
  </div>
</template>

<script>
import { BootstrapVue } from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios   from 'axios';
import rutas   from '@/assets/utils/rutas.json';
import actions from '@/assets/utils/utils'
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'; // Update the path accordingly
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import SignoModalEdit from '@/views/signosVitales/SignoModalEdit.vue';
import { comprobarPermisos, comprobarRoles, getEstablecimientoLS, getIdDoctorLS, convertDateToYYYYMMDD, getCurrentDate } from "@/shared/helpers";
import Swal from 'sweetalert2'
import { ROLES, MEDICO_DERIVACIONES }                from '@/shared/constants';
import { clearAtencionLS, clearDataAtencion }      from '@/views/atencionCita/helpers';
import { signosVitalesService } from '@/views/signosVitales/services';
import { citasService, informesService } from '@/views/citas/services';

import { SaveSignosVitales } from '@/views/signosVitales/components';
import { ButtonComentariosValidacion, CitasComentariosValidacion } from '../components';

library.add(faHeart);

export default {
  props: {
    estado: String,
  },

  components: {
    ...BootstrapVue.components,
    AppBreadcrumb,
    flatPickr,
    vSelect,
    SignoModalEdit,
    Swal,
    ButtonComentariosValidacion,
    CitasComentariosValidacion,
    SaveSignosVitales
  },


  data() {

    return {
      idCitaSeleccionado:null,
      paciente:null,

      filters:{
        search          : null,
        estadoCita      : null,
        estadoRevision  : null,
        establecimiento : null,
        especialidad    : null,
        cobertura       : null,
        fechaHoy        : null,
        fechaDesde      : null,
        fechaHasta      : null,
        observaciones   : null
      },
      
      filtersCopy:{},

      table:{
        page     : 1,
        perPage  : 15,
        totalRows: 0
      },

      cobertura: null,

      opsCobertura: [
        { value : '1', text : 'IESS',      },
        { value : '2', text : 'ISSPOL',    },
        { value : '3', text : 'ISSFA',     },
        { value : '4', text : 'MSP',       },
        { value : '5', text : 'PARTICULAR' }
      ],

      opsEstadoCita: [
        { value : '1', text : 'Esperando Signos',      },
        { value : '2', text : 'Esperando Atencion Dr.' },
        { value : '3', text : 'Atendida',     },
      ],

      opsEstadoRevision: [
        { value : '1', text : 'Creado',     },
        { value : '2', text : 'Por revisar' },
        { value : '3', text : 'Revisada',   },
        { value : '4', text : 'Concluida',  },
      ],

      fields: [
        // { key: 'establecimiento', label: 'Establecimiento', sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'paciente',        label: 'Paciente',           sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'fechaIngreso',    label: 'Fecha/Hora Ingreso', sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'fechaCita',       label: 'Fecha/Hora Cita',    sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'coberturaSeguro', label: 'Cobertura',          sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'doctor.nombre',   label: 'Doctor',             sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'especialidad',    label: 'Especialidad',       sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'estadoCita',      label: 'Estado Cita',        sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'usuarioCreador',  label: 'admision',           sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'archivosMsp',     label: 'Archivos MSP',       sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'estadoRev',       label: 'Estado Revision',    sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'acciones',        label: 'acciones',           sortable: true, thClass: 'text-center', tdClass: 'text-right', width: '150px' },
        { key: 'informes',        label: 'informes',           sortable: true, thClass: 'text-center', tdClass: 'text-right', width: '150px' },
      ],
      informesService,
      loadingTable : true,
      fechaCita    : null,
      edadPaciente : null,

      filtrarMspFaltantes: false,

      fechaCreacionFormateada: '',
      uSuario : null,
      idEstablecimiento : null,
      esAdmin: null,
      cargarMsp: true,

      componenteDinamico: null,
      showModal: false,

      tokenSeleccionado: null,
      filtroEstado: null, // Estado actual del filtro
      mostrarLoader: false,
      login_user: '',

      cantidadMSPFaltantes: null,
      nCitasSinAtencion: 0,

      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      doctor: null,
      establecimientos: [],
      opsespecialidad: [],
      user: null,
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
      },
      currentEstablecimiento: null,

      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      
      
      listaAcciones: [],
      token_usuario: '',
      items: [],
      descripcion: '',

      dataEditSignoModal : null,
      clearAtencionLS
    }
  },

  async created() {
    this.setToken();
    comprobarPermisos(this.$route);
    this.currentEstablecimiento = getEstablecimientoLS && getEstablecimientoLS();
    if (this.isXima) {
      await this.fetchEstablecimientos();
    }
    this.fetchEspecialidades();

    await this.loadFiltersLS();
    this.fetchConsultarCitas();

    this.$store.commit("resetImagenes");
    this.$store.commit("clearDataDientes");
    localStorage.removeItem('odontograma');
    const horaInicioAtencion = localStorage.getItem('horaInicioAtencion')
    if (horaInicioAtencion) {
      localStorage.setItem('horaInicioAtencion', '')
    }

    await clearDataAtencion();
    clearAtencionLS();
  },
  
  async mounted() {
    actions.setearTitulo('Citas');
    await clearDataAtencion();
  },
  

  methods: {
     isOdontologia(cita){
      console.log("entra", cita)
      let doctor = cita?.doctor
      if(doctor &&  doctor.codEsp && doctor.codEsp === '0000000134'){
        return true
      }else{return false}
    },

    async downloadForm033(idCita) {
      try {
        await informesService.getForm033(idCita);
      } catch (error) {
        const message =
          (error instanceof Error && error.message) ||
          "No se pudo descargar el Formulario 033.";

        if (this.$bvToast) {
          this.$bvToast.toast(message, {
            title: "Formulario 033",
            variant: "danger",
            solid: true,
          });
        } else if (this.$swal) {
          this.$swal.fire({
            icon: "error",
            title: "Formulario 033",
            text: message,
            confirmButtonColor: "#089599",
          });
        }
      }
    },

    loadFiltersLS(){
      const dataFiltersLs = JSON.parse(localStorage.getItem('filtersCitas'));
      if(!dataFiltersLs) return;
      this.filters = dataFiltersLs;
    },

    onClearFilters(){
      this.filters = {
        search          : null,
        establecimiento : null,
        especialidad    : null,
        cobertura       : null,
        fechaDesde      : null,
        fechaHasta      : null
      };
      
      localStorage.removeItem('filtersCitas');
      this.fetchConsultarCitas();
    },


    notwentyFourHours(fechaCreacionAtencion){
      if (!fechaCreacionAtencion) return false;

      const [datePart, timePart] = fechaCreacionAtencion.split(', ');
      const [day, month, year] = datePart.split('/');
      const [hours, minutes, seconds] = timePart.split(':');
      const creationDate = new Date(year, month - 1, day, hours, minutes, seconds);
      const currentDate  = new Date();       
      const diffInMs     = currentDate - creationDate;
      const diffInHours  = diffInMs / (1000 * 60 * 60);        
      return diffInHours < 24;
    },


    // permisos para ver botones de acciones
    showButtonVerCita(){
      const hasPermission = comprobarRoles([
        ROLES.ADMISION,
        ROLES.DOCTOR,
        ROLES.JEFE_MEDICO,
        ROLES.JEFE_VALIDACIONES,
        ROLES.AUDITOR,
        ROLES.JEFE_AUDITOR
      ]);
      return hasPermission;
    },

    showButtonEditarAtencion(item){

      const isJefeMedico = comprobarRoles([ROLES.JEFE_MEDICO]);

      // const limitDays = isJefeMedico 
      //   ? true
      //   : this.notwentyFourHours(item.fechaCreacionAtencion);
      const limitDays = true;

      const doctorValido = item.doctor.id !== MEDICO_DERIVACIONES.IMAGENES 
        && item.doctor.id !== MEDICO_DERIVACIONES.LABORATORIOS

      return (
        item.estadoCita === '3' 
        && limitDays
        && this.hasPermission('atencionmedica_crear_atencion')
        && doctorValido
      );
    },


    showButtonCrearSignos(item){
      const permisos = this.hasPermission('citamedica_crear_signosvital');
      const estadoSV = item.estadoSignosVitales === 0;

      const doctorValido = item.doctor.id !== MEDICO_DERIVACIONES.IMAGENES 
        && item.doctor.id !== MEDICO_DERIVACIONES.LABORATORIOS

      return permisos && estadoSV && doctorValido
    },


    showButtonEditarSignos(item){

      const permisos = this.hasPermission('citamedica_crear_signosvital') 
      const estadoSV = item.estadoSignosVitales === 1;

      const doctorValido = item.doctor?.id !== MEDICO_DERIVACIONES.IMAGENES 
        && item.doctor.id !== MEDICO_DERIVACIONES.LABORATORIOS;

      return permisos && estadoSV && doctorValido
    },


  
    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem('permisos');
      return permisosUsuario.indexOf(permission) !== -1;
    },

  
    showAppointmentState(idEstCi) {
      let estadocita = "";
      if (idEstCi === "1") {
        estadocita = "Espera Signos Vitales";
      } else if (idEstCi === "2") {
        estadocita = "Espera Atencion Doctor";
      } else if (idEstCi === "3") {
        estadocita = "Cita Atendida";
      }
      return estadocita;
    },


    estadoRevisionShow(value){
      const estadoRevisionsToShow = value === '1'
        ? 'Creado'
        : value === '2'
          ? 'Por revisar'
          : value === '3'
            ? 'Revisada'
            : value === '4'
              ? 'Concluida' : ""

      return estadoRevisionsToShow;
    },


    formatDateToISO(dateString) {
      if (!dateString) return '';
      const [day, month, year] = dateString.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  

    async fetchFaltanteMSP() {
      if (!this.idEstablecimiento) { this.cantidadMSPFaltantes = 0; return; }

      const query = `
        query MyQuery(
          $establecimiento : ID
          $fechaHoy        : Boolean
          $fechaDesde      : String
          $fechaHasta      : String
          $cobertura       : String
        ){
          urlsMspPacienteVacioCount(
            idEstablecimiento: $establecimiento
            fechaHoy         : $fechaHoy
            fechaDesde       : $fechaDesde
            fechaHasta       : $fechaHasta
            cobertura        : $cobertura
          )
        }
      `;

      const variables = {
        establecimiento: this.idEstablecimiento,
        fechaHoy       : this.filters.fechaHoy,
        fechaDesde     : this.filters.fechaDesde ? this.formatDateToISO(this.filters.fechaDesde) : '',
        fechaHasta     : this.filters.fechaHasta ? this.formatDateToISO(this.filters.fechaHasta) : '',
        cobertura      : this.filters.cobertura?.value
      }

      try {
        const response = await axios.post(`${rutas.axios}api`, { query, variables });
        this.cantidadMSPFaltantes = response.data.data.urlsMspPacienteVacioCount;

      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },


    async getCantidadSinHistoria() {
      if (!this.idEstablecimiento) { this.nCitasSinAtencion = 0; return; }

      const query = `
        query SinHistoriaClinicaCount(
            $establecimiento   : ID
            $fechaHoy          : Boolean
            $fechaDesde        : String
            $fechaHasta        : String
            $cobertura         : String
        ) {
          sinHistoriaClinicaCount(
            idEstablecimiento: $establecimiento
            fechaHoy         : $fechaHoy
            fechaDesde       : $fechaDesde
            fechaHasta       : $fechaHasta
            cobertura        : $cobertura
          )
        }

      `;

      const variables = {
        establecimiento: this.idEstablecimiento,
        fechaHoy       : this.filters.fechaHoy,
        fechaDesde     : this.filters.fechaDesde ? this.formatDateToISO(this.filters.fechaDesde) : '',
        fechaHasta     : this.filters.fechaHasta ? this.formatDateToISO(this.filters.fechaHasta) : '',
        cobertura      : this.filters.cobertura?.value
      }

      try {
        const response = await axios.post(`${rutas.axios}api`, { query, variables });
        this.nCitasSinAtencion = response.data.data.sinHistoriaClinicaCount;

      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },

    
  
  
    async fetchEspecialidades() {
      const query = `
        query {
          allEspecialidad {
            id
            descripcion
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.opsespecialidad = response.data.data.allEspecialidad.map(item => ({
          value: item.id,
          text: item.descripcion
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value    : item.id,
          text     : item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },
  
    cambiarPagina(newPage) {
      this.table.page = newPage;
      this.fetchConsultarCitas();
    },

  
    async fetchConsultarCitas() {

      this.filtersCopy = { ...this.filters };

      this.loadingTable = true;
      const establecimientoUser = this.currentEstablecimiento || (getEstablecimientoLS && getEstablecimientoLS());

      this.idEstablecimiento = this.isXima
        ? (this.filters.establecimiento?.value || (establecimientoUser && establecimientoUser.id ? establecimientoUser.id : null))
        : (establecimientoUser && establecimientoUser.id ? establecimientoUser.id : null);

      if (!this.idEstablecimiento && !this.isXima) {
        this.items = [];
        this.table.totalRows = 0;
        this.loadingTable = false;
        if (this.$bvToast) this.$bvToast.toast('Establecimiento no configurado.', { variant: 'warning' });
        return;
      }

      const idDoctor = getIdDoctorLS();
      const viewAll = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.AGENDAMIENTO]);


      const esSignos = await this.hasPermission('citamedica_crear_signosvital');
      const esAdmin  = await this.hasPermission('adm_crear_doctor');
      const esDoc    = await this.hasPermission('atencionmedica_crear_atencion');

      this.esAdmin   = esAdmin

      this.estActual = ''

      if (esSignos && !esAdmin) {
        this.estActual = '1';
      }

      if (esDoc && !esAdmin) {
        this.estActual = '2';
      }


      await this.fetchFaltanteMSP();
      await this.getCantidadSinHistoria();

      const params = {
        page            : this.table.page,
        pageSize        : this.table.perPage,
        doctorId        : viewAll ? '' : idDoctor,
        establecimiento : this.idEstablecimiento,
        nombre          : this.filters.search?.trim()        || '',
        cobertura       : this.filters.cobertura?.value      || '',
        especialidad    : this.filters.especialidad?.value   || '',
        estadoCita      : this.filters.estadoCita?.value     || '',
        estadoRevision  : this.filters.estadoRevision?.value || '',
        fechaHoy        : this.filters.fechaHoy,
        fechaDesde      : convertDateToYYYYMMDD(this.filters.fechaDesde) || '',
        fechaHasta      : convertDateToYYYYMMDD(this.filters.fechaHasta) || '',
        signosflag      : '0',
        mspFiltro       : this.filtrarMspFaltantes,
        observaciones   : this.filters.observaciones || ''
      }

      const responseCitas = await citasService.getAll(params);
      if (!responseCitas) return;

      const dataCitas      = responseCitas.data;
      this.table.totalRows = responseCitas.total;

      const citasMapped = await Promise.all(dataCitas.map(cita => this.citasMapper(cita)));

      this.items = citasMapped.filter( item => item );
      this.loadingTable = false

    },


    async citasMapper(cita){

      const dataPaciente = cita.paciente.persona;
      const tokenCita    = cita.token;
      let tokenAtencion  = null;

      if (cita?.consultacitamedicaSet.length > 0) {
        const matchingItem = cita.consultacitamedicaSet.find(setItem => setItem.estado === '1');

        if (!matchingItem) {
          console.error("No se encontró una atencion activa");
          return null;
        }
        tokenAtencion = matchingItem.token;
      }

      const establecimiento = cita.establecimiento.Descripcion;
      const paciente        = `${dataPaciente.identificacion} - ${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`
      const fechaIngreso    = new Date(cita.fechaCreacion).toLocaleString('es-ES', { 
        timeZone : 'America/Guayaquil', 
        year     : 'numeric', 
        month    : '2-digit', 
        day      : '2-digit', 
        hour     : '2-digit', 
        minute   : '2-digit', 
        second   : '2-digit' 
      });

      const fechaCita = `${cita.fechaCita} ${cita.horaCita}`;

      const historiaClinica = cita.paciente.numHistoriaClinica 
        ? JSON.parse(cita.paciente.numHistoriaClinica)
        : null;

      let historiaClinicaLocal = null;

      if (historiaClinica) {
        historiaClinicaLocal = historiaClinica[cita.establecimiento.id]
      }

      const cobertura       = cita.cobSeleccionada?.descripcion;
      const seguroString    = cita.detallescitaSet[0]?.detailsSeguro;
      const codigoSeguro    = seguroString ? JSON.parse(seguroString)?.seguroSalud?.code : '';
      const coberturaSeguro = `${cobertura} ${codigoSeguro ? `(${codigoSeguro}) ` : ''} ${cita.cobSeleccionada?.id === '1' ? `\nHC: ${historiaClinicaLocal}` : ''}`; 

      const titularesString = cita.detallescitaSet[0]?.detallesTitulares;
      const titulares       = titularesString ? JSON.parse(titularesString) : [];
      const nTitulares      = titulares?.length + 1;

      const coberturaPaciente  = cita.urlsMspPaciente ? 1 : 0;
      const coberturaTitular1  = cita.urlsMspTitular1 ? 1 : 0;
      const coberturaTitular2  = cita.urlsMspTitular2 ? 1 : 0;
      const coberturaTitular3  = cita.urlsMspTitular3 ? 1 : 0;
      const nCoberturasSubidas = coberturaPaciente + coberturaTitular1 + coberturaTitular2 + coberturaTitular3;

      const doctorEspecialidad = cita.doctor?.especialidad || {};
      const codEsp             = doctorEspecialidad.codEsp || "";
      const doctorPersona      = cita.doctor?.idPersona || {};
      const doctorNombre       = `${doctorPersona.primerApellido || ''} ${doctorPersona.primerNombre || ''}`.trim();
      const doctor = {
        id           : cita.doctor?.id || '',
        nombre       : doctorNombre || 'No asignado',
        especialidad : doctorEspecialidad.descripcion || 'No disponible',
        codEsp       : codEsp
      };

      const especialidad   = doctorEspecialidad.descripcion || 'No disponible';
      const usuarioCreador = cita.usuarioCreador ? cita.usuarioCreador.username : 'No disponible';

      const edadPaciente    = this.calcularEdad(cita.paciente.persona.fechaNacimiento);
      const tieneDescanso   = await informesService.tieneDescanso(cita.id);

      const itemMap = {
        idCita              : cita.id,
        tokenCita           : tokenCita,
        tokenAtencion       : tokenAtencion,
        
        establecimiento     : establecimiento,
        paciente            : paciente,
        fechaIngreso        : fechaIngreso,
        fechaCita           : fechaCita,
        cobertura           : cobertura,
        coberturaSeguro     : coberturaSeguro,
        doctor              : doctor,
        especialidad        : especialidad,
        usuarioCreador      : usuarioCreador,
        edadPaciente        : edadPaciente,
        nTitulares          : nTitulares,
        nCoberturasSubidas  : nCoberturasSubidas,
        colorArchivoMsp     : nTitulares === nCoberturasSubidas ? 'light-success' : 'light-secondary',

        estadoCita          : cita.estadoActual,
        estadoRev           : cita.estadoRevision,
        estadoSignosVitales : cita.estadoSignosvital,
        
        tieneDescanso       : tieneDescanso
      };

      return itemMap;
    },

    
    calcularEdad(fechaNacimiento) {
      const fechaNacimientoDate = new Date(fechaNacimiento);
      const hoy = new Date();
      let edad = hoy.getFullYear() - fechaNacimientoDate.getFullYear();
      const mesDiferencia = hoy.getMonth() - fechaNacimientoDate.getMonth();
      if (mesDiferencia < 0 || (mesDiferencia === 0 && hoy.getDate() < fechaNacimientoDate.getDate())) {
        edad--;
      }
    
      return edad;
    },

    async signosVitalid(tokenCita) {
      this.navigateToQuery('signosVitales', tokenCita);
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
  
    viewItem(tokenCita, idCita) {
      this.$store.commit('resetStateViewCita');
      this.showModal = true;
      this.tokenSeleccionado = tokenCita;
      this.idCitaSeleccionado = idCita
    },
  
    cargarComponente() {
      import('@/views/citas/components/VerCita/VerCita.vue').then(componente => {
        this.componenteDinamico = componente.default;
      }).catch(error => {
        console.error('Error al cargar el componente:', error);
      });
    },
  
    redirectToAtencionMedica(idCit) {
      this.$router.push({ name: 'crear_atencion_medica', params: { id: idCit } });
      const horaInicio = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      
      localStorage.setItem('horaInicioAtencion', horaInicio )
    },


    async redirectToEditAtencionMedica(tokenAtencion) {
      this.$router.push({ name: 'editar_atencion_medica', params: { token: tokenAtencion } });
    },
    
  
    fetchConsultarCitaPdf() {
      this.fetchConsultarCitas();
    },


    fetchConsultarCitaExcel() {
      this.fetchConsultarCitas();
    },
  
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

  
    async buscarCita() {
      await this.fetchConsultarCitas();
    },


    redirectToCrearCita() {
      this.$router.push({ name: 'crear_cita' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },

    canDownloadActaEntrega(estadoCita){
      return estadoCita === '3' && comprobarRoles([ROLES.JEFE_MEDICO])
    },

    canDownloadCertificadoAsistencia(estadoCita){
      return estadoCita === '3' && comprobarRoles([ROLES.ADMISION, ROLES.DOCTOR, ROLES.JEFE_MEDICO])
    },

    canDownloadCertificadoDescanso(item){
      return item.estadoCita === '3' && item.tieneDescanso && comprobarRoles([ROLES.ADMISION, ROLES.DOCTOR, ROLES.JEFE_MEDICO])
    }
  },


  computed: {
    isXima() {
      return this.currentEstablecimiento?.uniCodigo === '36451';
    },

    tableFields() {
      if (!this.isXima) return this.fields;

      return [
        { key: 'establecimiento', label: 'Establecimiento', sortable: true, thClass: 'text-center', width: '150px' },
        ...this.fields,
      ];
    },

    isAdmin(){
      return comprobarRoles([ROLES.JEFE_VALIDACIONES, ROLES.AUDITOR, ROLES.JEFE_AUDITOR]);
    },

    canViewAllEstablecimientos(){
      return comprobarRoles([ROLES.JEFE_VALIDACIONES, ROLES.AUDITOR, ROLES.JEFE_AUDITOR]);
    },


    canCreateCitas(){
      return comprobarRoles([ROLES.ADMISION, ROLES.JEFE_MEDICO])
    },


    getFiltrosAplicados() {
      const filtrosAplicados = [];

      if(this.filtersCopy.search)
        filtrosAplicados.push(`Busqueda: ${this.filtersCopy.search}`)

      if(this.filtersCopy.especialidad)
        filtrosAplicados.push(`Especialidad: ${this.filtersCopy.especialidad.text}`)

      if(this.filtersCopy.cobertura)
        filtrosAplicados.push(`Cobertura: ${this.filtersCopy.cobertura.text}`)

      if(this.filtersCopy.estadoCita)
        filtrosAplicados.push(`Estado Cita: ${this.filtersCopy.estadoCita.text}`)

      if(this.filtersCopy.establecimiento && this.isXima)
        filtrosAplicados.push(`Establecimiento: ${this.filtersCopy.establecimiento.text}`)

      if(this.filtersCopy.estadoRevision)
        filtrosAplicados.push(`Estado Revision: ${this.filtersCopy.estadoRevision.text}`)

      if(this.filtersCopy.fechaHoy)
        filtrosAplicados.push(`Citas de hoy`)

      if(this.filtersCopy.fechaDesde)
        filtrosAplicados.push(`Desde: ${this.filtersCopy.fechaDesde}`)

      if(this.filtersCopy.fechaHasta)
        filtrosAplicados.push(`Hasta: ${this.filtersCopy.fechaHasta}`)

      if(this.filtersCopy.observaciones === 'sinCedulas')
        filtrosAplicados.push(`Sin cedulas`)

      return filtrosAplicados.join('<br>');
    }
  },


  watch: {
    filters:{
      deep: true,
      handler(){
        localStorage.setItem('filtersCitas', JSON.stringify(this.filters));
      }
    }
  },

}
</script>
  
<style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  
  .invoice-filter-select {
    min-width: 190px;

    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }

    ::v-deep .vs__selected {
      width: 100px;
    }
  }
  
  .estado-cita {
    background-color: rgb(188, 189, 236);
    font-weight: bold;
    color: black;
    text-align: center;
  }
  
  .custom-red-button {
    background-color: red !important;
    border-color: red !important;
  }
  
  .light-success {
    background-color: #d4edda;
    color: #155724;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
  }
  
  .light-secondary {
    background-color: #f8d7da;
    color: #721c24;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
  }
  </style>
  
